module.exports = __webpack_public_path__ + "static/img/cabecalho_qma_pdf.b57f945.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/qma/cabecalho_qma_pdf.svg
// module id = PL0N
// module chunks = 0